import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import cls from 'classnames'
import { ModalPortal } from 'hlj-components'
import style from '../style.module.less'

@inject('menuStore')
@observer
export default class SubMenu extends Component {
  constructor(props) {
    super(props)

    // 用于延时处理鼠标移入移出切换菜单
    this.isIn = false
  }

  render() {
    const {
      menuStore: { menuData, onMenuOpenChange, menuOffset },
      item: { id, title, icon }
    } = this.props
    const key =
      menuData.selectedKeyPath.length > 0
        ? menuData.selectedKeyPath[0]
        : undefined
    const isMenuSelected = key && key === id
    const isActive = menuData.openKey == id

    return (
      <div
        className={cls(style.menu, style['sub-menu'], {
          [style['menu-active']]: isActive,
          [style['menu-selected']]: isMenuSelected
        })}
      >
        <div
          onMouseEnter={() => {
            this.isIn = true

            setTimeout(() => {
              if (this.isIn) {
                if (!isActive) {
                  onMenuOpenChange(id)
                }
              }
            }, 100)
          }}
          onMouseLeave={() => {
            this.isIn = false
          }}
          className={style['sub-menu-title']}
        >
          {icon && <i className={`iconfont ${icon}`} />}
          <span>{title}</span>
        </div>

        <ModalPortal>
          <div
            className={cls(style['sub-menu-wrapper'], {
              [style['menu-hidden']]: !isActive
            })}
            style={{
              height: `calc(100% - ${menuOffset}px)`,
              top: menuOffset
            }}
          >
            {this.props.children}
          </div>
        </ModalPortal>
      </div>
    )
  }
}
